import React from "react";
import oeuf from "./oeuf.png";

const Coin = ({ amount, animated = false }) => {
  return (
    <span className="inline-flex items-center gap-2">
      {/* Icône style pièce */}
      <span
        className={`relative w-6 h-6 inline-flex items-center justify-center ${animated ? "animate-spin-slow" : ""}`}
      >
        <img src={oeuf} alt="coin" className="w-6 h-6 object-contain" />
      </span>

      {/* Montant */}
      <span className={`font-bold text-yellow-500 drop-shadow ${animated ? "animate-pulse" : ""}`}>
        {amount}
      </span>
    </span>
  );
};

export default Coin;
